<template>
    <div class="main">
        <!-- 頁首 -->
        <Header :title="title" :isBack="true" />
        <!-- 主體 -->
        <div class="mainContent">
            <div class="container">

                <!-- 查詢列 -->
                <div class="w3-container w3-padding">
                    <div class="w3-row">
                        <label>年度</label>
                        <v-select :searchable="false" :clearable="false" v-model="crop_query.input.year.value" :options="crop_query.input.year.list" :reduce="(option) => option.value" label="text" placeholder="請選擇年度"></v-select>
                    </div>
                    <div class="w3-row" style="margin-top:8px;">
                        <label>期別</label>
                        <v-select :searchable="false" :clearable="false" v-model="crop_query.input.period.value" :options="crop_query.input.period.list" :reduce="(option) => option.value" label="text" placeholder="請選擇期別" :disabled="!crop_query.input.year.value"></v-select>
                    </div>
                    <div class="w3-row" style="margin-top:8px;">
                        <label>作物</label>
                        <v-select :searchable="false" :clearable="false" v-model="crop_query.input.crop.value" :options="crop_query.input.crop.list" :reduce="(option) => option.value" label="text" placeholder="請選擇作物" :disabled="!crop_query.input.period.value"></v-select>
                    </div>
                    <div class="w3-row" style="margin-top:12px;">
                        <button class="w3-button w3-teal w3-round w3-block" @click="queryCropArea()">查詢</button>
                    </div>
                </div>

                <!-- 結果區塊 -->
                <div v-if="crop_query.hasResult">

                    <!-- 縣市摘要 -->
                    <div class="w3-card w3-padding w3-margin">
                        <h4 style="color:#1D976C;margin-bottom:12px;">
                            {{ crop_query.result.city.city }}
                            {{ crop_query.result.city.year }}年
                            {{ crop_query.result.city.period }}
                            {{ crop_query.result.city.crop }}
                        </h4>
                        <div class="summary-grid">
                            <div class="w3-card w3-padding w3-center summary-card">
                                <div class="summary-label">種植面積</div>
                                <div class="summary-value">{{ crop_query.result.city.area_p }}</div>
                                <div class="summary-unit">公頃</div>
                            </div>
                            <div class="w3-card w3-padding w3-center summary-card">
                                <div class="summary-label">收穫面積</div>
                                <div class="summary-value">{{ crop_query.result.city.area_h }}</div>
                                <div class="summary-unit">公頃</div>
                            </div>
                            <div class="w3-card w3-padding w3-center summary-card">
                                <div class="summary-label">每公頃收穫量</div>
                                <div class="summary-value">{{ crop_query.result.city.rate_h }}</div>
                                <div class="summary-unit">公斤</div>
                            </div>
                            <div class="w3-card w3-padding w3-center summary-card">
                                <div class="summary-label">收量</div>
                                <div class="summary-value">{{ crop_query.result.city.harvest }}</div>
                                <div class="summary-unit">公噸</div>
                            </div>
                        </div>
                    </div>

                    <!-- 圖表 -->
                    <div class="w3-container">
                        <h5 style="color:#1D976C;">各鄉鎮種植面積</h5>
                        <div class="w3-row" style="overflow-x:auto;overflow-y:hidden;">
                            <div id="chart_crop_query_town"></div>
                        </div>
                    </div>

                    <!-- 鄉鎮明細表格 -->
                    <div class="w3-container" style="margin-top:16px;margin-bottom:32px;">
                        <h5 style="color:#1D976C;">鄉鎮明細</h5>
                        <table class="global-table w3-table w3-striped w3-bordered">
                            <tr class="header table-tr">
                                <th>鄉鎮</th>
                                <th>種植面積<br/>(公頃)</th>
                                <th>收穫面積<br/>(公頃)</th>
                                <th>每公頃收穫量<br/>(公斤)</th>
                                <th>收量<br/>(公噸)</th>
                            </tr>
                            <tr class="body"
                                v-for="(item, index) in crop_query.result.towns"
                                :key="index"
                                :class="index % 2 === 0 ? 'table-td-single' : 'table-td-double'">
                                <td>{{ item.town }}</td>
                                <td>{{ item.area_p }}</td>
                                <td>{{ item.area_h }}</td>
                                <td>{{ item.rate_h }}</td>
                                <td>{{ item.harvest }}</td>
                            </tr>
                            <tr class="footer table-tr">
                                <td>合計</td>
                                <td>{{ crop_query.result.city.area_p }}</td>
                                <td>{{ crop_query.result.city.area_h }}</td>
                                <td>—</td>
                                <td>{{ crop_query.result.city.harvest }}</td>
                            </tr>
                        </table>
                    </div>

                </div>

                <!-- 資料來源 -->
                <div class="w3-container w3-padding" style="margin-top:16px;margin-bottom:24px;">
                    <small style="color:#999;">
                        資料來源：<a href="https://data.moa.gov.tw/open_detail.aspx?id=038" target="_blank" style="color:#1D976C;">農業部農業資料開放平台</a>
                    </small>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Header from '@/components/pwa/Header.vue'
export default {
    created() {
        window.vue = this;
        window.ChartCropQueryTown = null;
        if(!window.checkLogin()){ window.setPage("login"); }
    },
    components: {
        Header
    },
    data(){
        return {
            apiGetCropYear: (data) => this.userRequest.post("API/Default/CropYear", data),
            apiGetCropList: (data) => this.userRequest.post("API/Default/CropList", data),
            apiGetCropAreaList: (data) => this.userRequest.post("API/Default/CropAreaList", data),

            title: "農情作物查詢",
            crop_query: {
                input: {
                    year:   { value: "", list: [] },
                    period: { value: "", list: [] },
                    crop:   { value: "", list: [] },
                },
                hasResult: false,
                result: {
                    city:  { city: "", year: "", period: "", crop: "", area_h: 0, area_p: 0, rate_h: 0, harvest: 0 },
                    towns: [],
                },
            },
        }
    },
    mounted(){
        window.vue = this;
        this.initCropYear();
    },
    watch: {
        "crop_query.input.year.value": function(val){
            this.crop_query.input.period.value = "";
            this.crop_query.input.period.list = [];
            this.crop_query.input.crop.value = "";
            this.crop_query.input.crop.list = [];

            if(val != "" && val != null){
                var index = -1;
                for(var i=0 ; i<this.crop_query.input.year.list.length ; i++){
                    if(this.crop_query.input.year.list[i].value == val){ index = i; }
                }
                if(index >= 0){
                    var list = this.crop_query.input.year.list[index].period.split(",");
                    for(var j=0 ; j<list.length ; j++){
                        this.crop_query.input.period.list.push({ value: list[j], text: list[j] });
                    }
                }
            }
        },
        "crop_query.input.period.value": function(val){
            this.crop_query.input.crop.value = "";
            this.crop_query.input.crop.list = [];
            if(val != "" && val != null){ this.getCropList(); }
        },
    },
    methods: {
        initCropYear(){
            this.FunctionToken(this.doCropYear, {});
        },
        doCropYear(data){
            this.apiGetCropYear(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                const jsonData = JSON.parse(json.Data);
                if(json.Status){
                    this.crop_query.input.year.list = [];
                    for(var i=0 ; i<jsonData.length ; i++){
                        this.crop_query.input.year.list.push({
                            value: jsonData[i].A_YEAR,
                            text: String(jsonData[i].A_YEAR),
                            period: jsonData[i].PERIOD,
                        });
                    }
                }
            })
            .catch((err) => { console.log(err); });
        },
        getCropList(){
            this.FunctionToken(this.doCropList, {
                year: this.crop_query.input.year.value,
                period: this.crop_query.input.period.value,
            });
        },
        doCropList(data){
            this.apiGetCropList(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                const jsonData = JSON.parse(json.Data);
                if(json.Status){
                    this.crop_query.input.crop.list = [];
                    for(var i=0 ; i<jsonData.length ; i++){
                        this.crop_query.input.crop.list.push({
                            value: jsonData[i].CROP,
                            text: jsonData[i].CROP,
                        });
                    }
                }
            })
            .catch((err) => { console.log(err); });
        },
        queryCropArea(){
            if(!this.crop_query.input.year.value){ alert("請選擇年度"); return; }
            if(!this.crop_query.input.period.value){ alert("請選擇期別"); return; }
            if(!this.crop_query.input.crop.value){ alert("請選擇作物"); return; }

            this.enableMask();
            this.FunctionToken(this.doCropAreaList, {
                crop: this.crop_query.input.crop.value,
                period: this.crop_query.input.period.value,
                year: this.crop_query.input.year.value,
                area: 0,
            });
        },
        doCropAreaList(data){
            this.apiGetCropAreaList(data)
            .then((res) => {
                const json = JSON.parse(res.data);
                const jsonData = JSON.parse(json.Data);
                var city_area = jsonData.CITY_AREA;
                var agri_survey = jsonData.BA_AGRI_SURVEY;

                this.crop_query.result.city = {
                    city:    city_area.CITY,
                    year:    city_area.A_YEAR,
                    period:  city_area.PERIOD,
                    crop:    city_area.CROP,
                    area_h:  this.getRounded(city_area.AREA_H),
                    area_p:  this.getRounded(city_area.AREA_P),
                    rate_h:  this.getRounded(city_area.RATE_H),
                    harvest: this.getRounded(city_area.HARVEST / 1000),
                };

                this.crop_query.result.towns = agri_survey
                    .filter(item => item.AREA_P > 0)
                    .sort((a, b) => b.AREA_P - a.AREA_P)
                    .map(item => ({
                        town:    item.TOWN,
                        area_h:  this.getRounded(item.AREA_H),
                        area_p:  this.getRounded(item.AREA_P),
                        rate_h:  this.getRounded(item.RATE_H),
                        harvest: this.getRounded(item.HARVEST / 1000),
                    }));

                this.crop_query.hasResult = true;
                this.setCropQueryChart();
                this.disableMask();
            })
            .catch((err) => {
                console.log(err);
                this.disableMask();
            });
        },
        setCropQueryChart(){
            const towns = this.crop_query.result.towns;
            var data = [];
            for(var i=0 ; i<towns.length ; i++){
                data.push({ x: towns[i].town, y: towns[i].area_p });
            }
            window.ThreadTool.ClearDelay(window.vue.timeout_id_chart_crop_query);
            window.vue.timeout_id_chart_crop_query = window.ThreadTool.Delay(function(){
                window.setChartCropQueryTown("#chart_crop_query_town", { data: data });
            }, this.delay_ms_chart);
        },
    }
}
</script>
<style>
    .summary-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
    }
    .summary-card {
        background: #ecfff8;
    }
    .summary-label {
        font-size: 12px;
        color: #666;
    }
    .summary-value {
        font-size: 18px;
        font-weight: bold;
        color: #1D976C;
    }
    .summary-unit {
        font-size: 12px;
        color: #666;
    }
    .table-tr {
        background: #1D976C;
        color: #FFFFFF;
    }
    .table-td-single {
        background: #ecfff8;
        color: #000000;
    }
    .table-td-double {
        background: #99D0BC;
        color: #000000;
    }
</style>
